import { TTypeOfCodec } from "../../../shared/src/codecs/codec";
import { array } from "../../../shared/src/codecs/types/array";
import { formIO } from "../../../shared/src/codecs/types/formIO";
import { integer } from "../../../shared/src/codecs/types/integer";
import { required } from "../../../shared/src/codecs/types/required";
import { string } from "../../../shared/src/codecs/types/string";

export const ListingProfitReportRow = required({
    listing_id: string(),
    address: string(),
    status: string(),
    total_forecast_net_pence: integer(),
    total_actual_net_pence: integer(),
    total_blended_net_pence: integer(),
});
export type TListingProfitReportRowCodec = typeof ListingProfitReportRow;
export type TListingProfitReportRow = TTypeOfCodec<TListingProfitReportRowCodec>;

export const ListingsProfitReportOutput = required({
    rows: array(ListingProfitReportRow),
});
export type TListingsProfitReportOutputCodec = typeof ListingsProfitReportOutput;
export type TListingsProfitReportOutput = TTypeOfCodec<TListingsProfitReportOutputCodec>;

export const ListingsProfitReportFormIO = formIO(required({}), ListingsProfitReportOutput);
export type TListingsProfitReportFormIOCodec = typeof ListingsProfitReportFormIO;
export type TListingsProfitReportFormIO = TTypeOfCodec<TListingsProfitReportFormIOCodec>;
